import React from 'react';
import {
  Create,
  SimpleForm,
  TopToolbar,
  ListButton,
  useNotify,
  useRedirect,
} from 'react-admin';
import { LeadForm } from './LeadForm';

const CreateActions = () => (
  <TopToolbar>
    <ListButton />
  </TopToolbar>
);

export const LeadCreate = () => {
  const notify = useNotify();
  const redirect = useRedirect();

  const onSuccess = (data: any) => {
    notify('Lead created successfully', { type: 'success' });
    redirect('show', 'leads', data.id);
  };

  return (
    <Create actions={<CreateActions />} mutationOptions={{ onSuccess }}>
      <SimpleForm>
        <LeadForm isEdit={false} />
      </SimpleForm>
    </Create>
  );
};